export default __webpack_public_path__ + "static/media/TPBank.51682bf9.png";